export const createDeleteMessagesExternalSteps = [
  {
    selector: "#client-select",
    content:
      "Select the client whose messages you want to delete. This is a required field to proceed.",
  },
  {
    selector: "#client-environment-filter-group",
    content:
      "Optionally select one or more environments to narrow your deletion scope. If none are selected, all environments for the chosen client will be included.",
  },
  {
    selector: "#channel-filter-group",
    content:
      "Optionally select specific channels to target. Available options update based on your selected client and environments. If no channels are selected, all matching channels will be included.",
  },
  {
    selector: "#date-range-toggle",
    content:
      "Enable this option to delete messages across a range of dates instead of a single day. When selected, both Start Date and End Date fields will appear.",
  },
  {
    selector: "#delete-message-date-picker",
    content:
      "Choose the date or date range for message deletion. All messages received on the selected date(s) will be permanently removed from S3 storage.",
  },
  {
    selector: "#delete-messages-submit-button",
    content:
      "Click Submit to review your request. A confirmation window will display the channels affected. To proceed, type 'delete messages' exactly as shown to confirm the deletion.",
  },
];

export const deleteMessagesTaskDetailsSteps = [
  {
    selector: "#delete-task-summary",
    content:
      "View key details about the task, including Task ID, Client Name, Environment Name, Status, Outcome, and any related status messages or error information.",
  },
  {
    selector: "#delete-task-success-details",
    content:
      "For completed tasks with a successful outcome, review deletion metrics such as Deleted Size (GB), Delete Job ID, Deleted Count, Total Prefixes Processed, and Completed Prefixes.",
  },
  {
    selector: "#delete-task-report-table",
    content:
      "View a detailed breakdown of deleted messages by Channel and Date. Each row shows the channel name and the corresponding date range for the deletions.",
  },
];
